import { FC, RefObject } from "react";

import styles from "./full-ui.module.scss";
import { SectionSidebar } from "./section-sidebar";

export interface FullUIProps {
  header?: React.ReactNode;
  sidebar?: React.ReactNode;
  sidebarRef?: RefObject<SectionSidebar>;
  bottom?: React.ReactNode;
}

export const FullUI: FC<FullUIProps> = ({
  sidebar,
  sidebarRef,
  bottom,
  children,
}) => {
  return (
    <div className={styles.wrapper}>
      <SectionSidebar ref={sidebarRef}>{sidebar}</SectionSidebar>
      <div className={styles.mainColumn}>
        {children}
        {bottom}
      </div>
    </div>
  );
};
